var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ob1-search-field", {
    attrs: {
      id: "search-field",
      label: _vm.placeHolder,
      "show-auto-completion": _vm.showAutoCompletion,
      "tms-button-category": _vm.tmsCategory,
      "tms-button-action": _vm.tmsButtonAction,
      "tms-button-label": _vm.computeTmsLabel(),
      "tms-result-category": _vm.tmsCategory,
      "tms-result-action": _vm.tmsResultAction,
      "tms-result-label": _vm.computeTmsLabel(),
    },
    on: { input: _vm.inputSearchFiledHandler },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }